module.exports = __webpack_public_path__ + "static/media/check-btn.0dd3d351.svg";